import { render, staticRenderFns } from "./ShiftEditorEmployeeSelectorDialog.vue?vue&type=template&id=2dc62691&scoped=true&lang=pug&"
import script from "./ShiftEditorEmployeeSelectorDialog.vue?vue&type=script&lang=ts&"
export * from "./ShiftEditorEmployeeSelectorDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftEditorEmployeeSelectorDialog.vue?vue&type=style&index=0&id=2dc62691&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc62691",
  null
  
)

export default component.exports